import { Text } from "@chakra-ui/react";

function Label({ children }: any) {
  return <Text textStyle={"paragraph"}>{children}</Text>;
}

export default Label;
